import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      fill="none"
      viewBox="0 0 12 12"
    >
      <g clipPath="url(#clip0_2254_33696)">
        <path
          fill="#525358"
          d="M6.786 10.135l4.905-4.906a1.052 1.052 0 00-.746-1.8h-9.81a1.056 1.056 0 00-.746 1.8l4.906 4.906a1.054 1.054 0 001.491 0z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2254_33696">
          <path fill="#fff" d="M0 0H12V12H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
